module.exports = __webpack_public_path__ + "media/Eat_Us_Alive_Teaser.33fefe2b.mp4";